import {ReactNode} from 'react'
import {Divider} from '@/components/ui/divider/Divider'
import {SidebarBody, SidebarHeader, SidebarSlot, SidebarWrapper} from '@/components/ui/sidebar-atoms/SidebarAtoms'

interface SidebarProps {
    startSlot?: ReactNode
    centerSlot?: ReactNode
    endSlot?: ReactNode
}

export const Sidebar = ({startSlot, centerSlot, endSlot}: SidebarProps) => {
    return (
        <SidebarWrapper>
            {startSlot && <SidebarHeader>{startSlot}</SidebarHeader>}
            {!startSlot && <Divider direction="horizontal" />}

            <SidebarBody>{centerSlot && <SidebarSlot>{centerSlot}</SidebarSlot>}</SidebarBody>

            {endSlot && <SidebarSlot>{endSlot}</SidebarSlot>}
        </SidebarWrapper>
    )
}
